import { latinToCyrillicSerbian } from '@/lib/i18n/latinToCyrillicSerbian';
import type { BlogPost, BlogPostRaw } from './types';

export function withSerbianCyrlBlogPosts(raw: BlogPostRaw[]): BlogPost[] {
  return raw.map((p) => ({
    ...p,
    translations: {
      ...p.translations,
      'sr-cyrl': {
        title: latinToCyrillicSerbian(p.translations.sr.title),
        metaTitle: latinToCyrillicSerbian(p.translations.sr.metaTitle),
        metaDescription: latinToCyrillicSerbian(p.translations.sr.metaDescription),
        excerpt: latinToCyrillicSerbian(p.translations.sr.excerpt),
      },
    },
    externalRefs: p.externalRefs.map((ref) => ({
      url: ref.url,
      label: {
        ...ref.label,
        'sr-cyrl': latinToCyrillicSerbian(ref.label.sr),
      },
    })),
  }));
}
